import colorPalette from './colorPalette';
import MAP_STYLES from './mapStyles';

const {
    COLOR_LANDSCAPE,
    COLOR_BORDERS,
    COLOR_WATER,
    COLOR_LINE,
    COLOR_POINT_FILL,
    COLOR_SELECTED_POINT,
    COLOR_PRIMARY,
    COLOR_SECONDARY,
    COLOR_DARKBLUE
} = colorPalette;

const COLORS = {
    BORDERS: COLOR_BORDERS,
    LANDSCAPE: COLOR_LANDSCAPE,
    LINE: COLOR_LINE,
    POINT: COLOR_SELECTED_POINT,
    POINT_FILL: COLOR_POINT_FILL,
    WATER: COLOR_WATER,
    MARKER_STROKE_NORMAL: '#ffffff',
    MARKER_FILL_NORMAL: COLOR_DARKBLUE,
    MARKER_STROKE_ACTIVE: '#ffffff',
    MARKER_FILL_ACTIVE: COLOR_PRIMARY,
};

const MARKER_ICON_DEFAULTS = {
    path: 'M 0, 0 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0',
    strokeOpacity: 0.7,
    strokeWeight: 4,
    fillOpacity: 1,
    scale: 1.325
}

const POINT_MARKER_ICON_CONFIG = {
    normal: {
        ...MARKER_ICON_DEFAULTS,
        ...{
            strokeColor: COLORS.MARKER_STROKE_NORMAL,
            fillColor: COLORS.MARKER_FILL_NORMAL,
        }
    },
    active: {
        ...MARKER_ICON_DEFAULTS,
        ...{
            strokeColor: COLORS.MARKER_STROKE_ACTIVE,
            fillColor: COLORS.MARKER_FILL_ACTIVE,
        }
    }
};

const LINE_SYMBOL_CONFIG = {
    path: 'M 0,-2 0,2',
    strokeOpacity: 1,
    strokeWeight: 2,
    scale: 1
};

const LINE_PATH_CONFIG = {
    clickable: false,
    geodesic: false,
    strokeOpacity: 0,
    strokeColor: COLORS.LINE,
    icons: [
        {
            icon: LINE_SYMBOL_CONFIG,
            repeat: '10px'
        }
    ]
};

const INFO_WINDOW_CONFIG = {
    content: '<p>info window</p>',
    disableAutoPan: true,
    maxWidth: 260,
}

const MARKER_CLUSTERER_STYLES = [
    {
        url: '/img/icons/svg/map-cluster-icon1.svg',
        height: 35,
        width: 35,
        // anchor: [16, 0],
        textColor: '#ffffff',
        textSize: 10
    },
    {
        url: '/img/icons/svg/map-cluster-icon2.svg',
        height: 45,
        width: 45,
        // anchor: [24, 0],
        textColor: '#ffffff',
        textSize: 11
    },
    {
        url: '/img/icons/svg/map-cluster-icon3.svg',
        height: 55,
        width: 55,
        // anchor: [32, 0],
        textColor: '#ffffff',
        textSize: 12
    }
];

const MARKER_ICONS = {
    /* wolfnet */
    wolfnet:                '/img/icons/svg/map-marker--dark-blue.svg',
    wolfnetWithLabel:       '/img/icons/svg/map-marker-with-label--dark-blue.svg',
    wolfnetActive:          '/img/icons/svg/map-marker--yellow.svg',
    wolfnetWithLabelActive: '/img/icons/svg/map-marker-with-label--yellow.svg',

    /* rw */
    'for-rent':                     '/img/icons/map-marker--dark-blue.png',
    'for-rentWithLabel':            '/img/icons/map-marker-with-label--dark-blue.png',
    'for-rentActive':               '/img/icons/map-marker--dark-blue.png',
    'for-rentWithLabelActive':      '/img/icons/map-marker-with-label--dark-blue.png',

    /* rf */
    'for-sale':                     '/img/icons/map-marker--dark-blue.png',
    'for-saleWithLabel':            '/img/icons/map-marker-with-label--dark-blue.png',
    'for-saleActive':               '/img/icons/map-marker--dark-blue.png',
    'for-saleWithLabelActive':      '/img/icons/map-marker-with-label--dark-blue.png',

    /* disabled */
    'disabled':                     '/img/icons/map-marker--gray.png',
    'disabledWithLabel':            '/img/icons/map-marker-with-label--gray2.png',
    'disabledActive':               '/img/icons/map-marker--dark-gray.png',
    'disabledWithLabelActive':      '/img/icons/map-marker-with-label--dark-gray.png',


    // SVGs -- BAD FOR PERFORMANCE
    // 'for-rent':                     '/img/icons/svg/map-marker--pink.svg',
    // 'for-rentWithLabel':            '/img/icons/svg/map-marker-with-label--pink.svg',
    // 'for-rentActive':               '/img/icons/svg/map-marker--dark-blue.svg',
    // 'for-rentWithLabelActive':      '/img/icons/svg/map-marker-with-label--dark-blue.svg',

    // /* rf */
    // 'for-sale':                     '/img/icons/svg/map-marker--dark-blue.svg',
    // 'for-saleWithLabel':            '/img/icons/svg/map-marker-with-label--dark-blue.svg',
    // 'for-saleActive':               '/img/icons/svg/map-marker--pink.svg',
    // 'for-saleWithLabelActive':      '/img/icons/svg/map-marker-with-label--pink.svg',

    // /* disabled */
    // 'disabled':                     '/img/icons/svg/map-marker--gray.svg',
    // 'disabledWithLabel':            '/img/icons/svg/map-marker-with-label--gray2.svg',
    // 'disabledActive':               '/img/icons/svg/map-marker--dark-gray.svg',
    // 'disabledWithLabelActive':      '/img/icons/svg/map-marker-with-label--dark-gray.svg',
};
// const MARKER_ICONS = {
//     /* wolfnet */
//     // wolfnet:                '/img/icons/svg/map-marker--dark-blue.svg',
//     // wolfnetWithLabel:       '/img/icons/svg/map-marker-with-label--dark-blue.svg',
//     // wolfnetActive:          '/img/icons/svg/map-marker--yellow.svg',
//     // wolfnetWithLabelActive: '/img/icons/svg/map-marker-with-label--yellow.svg',

//     /* rw */
//     wolfnet:                     '/img/icons/svg/map-marker--pink.svg',
//     wolfnetWithLabel:            '/img/icons/svg/map-marker-with-label--pink.svg',
//     wolfnetActive:               '/img/icons/svg/map-marker--light-blue.svg',
//     wolfnetWithLabelActive:      '/img/icons/svg/map-marker-with-label--dark-blue.svg',
// };

const defaultZoomLevels = {

    'for-rent': {
        address: 17,
        county: 10,
        city: 11,
        zipcode: 12,
        state: 7,
    },
    'for-sale': {
        address: 17,
        county: 10,
        city: 11,
        zipcode: 12,
        state: 7,
    }
};

const mapSettings = {
    clickableIcons: false,
    streetViewControl: true,
    panControlOptions: false,
    gestureHandling: 'greedy',
    backgroundColor: COLORS.COLOR_BACKGROUND,
    mapTypeControl: false,
    autopan: false,
    zoomControlOptions: {
        style: 'SMALL'
    },
    zoom: 4,
    minZoom: 7,
    maxZoom: 20,
    styles: MAP_STYLES
};

export { 
    mapSettings, 
    defaultZoomLevels, 
    LINE_PATH_CONFIG, 
    POINT_MARKER_ICON_CONFIG, 
    MARKER_CLUSTERER_STYLES,
    MARKER_ICONS,
    INFO_WINDOW_CONFIG
};
